import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { activatePipeline as activatePipelineAction } from '@redux/actions/pipelineActions';
import { activatePipelineActionStatusSelector } from '@redux/selectors/pipelineSelectors';
import { useStateCleanup } from './useStateCleanup';

const useActivatePipeline = () => {
  const dispatch = useDispatch();
  const activatePipelineActionStatus = useSelector(activatePipelineActionStatusSelector);

  const { reset } = useStateCleanup();

  const activatePipeline = useCallback(
    async ({ pipelineName, isExternal }: { pipelineName: string; isExternal?: boolean }) => {
      dispatch(activatePipelineAction({ pipelineName, isExternal }));
    },
    [dispatch],
  );

  const resetActivatePipelineActionStatus = useCallback(() => {
    reset(['pipelineStore.activatePipelineActionStatus']);
  }, [reset]);

  return {
    activatePipeline,
    activatePipelineActionStatus,
    resetActivatePipelineActionStatus,
  };
};

export default useActivatePipeline;
